import ISampleComponent, { ISampleOption } from '@components/FormFlow/Interfaces/FormflowComponents/ISampleComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import I18n from '@src/i18n';
import styled, { Theme } from '@src/styled-components';
import { Col, Icon, InputNumber, Row, Select } from 'antd';
import React from 'react';

import ProcessContext from '../ProcessContext';

const Option = Select.Option;

interface ISampleComponentPropsType {
  options?: string;
  onChange: Function;
}


interface ISampleTaskComponentStateType {

  label: string | undefined;
  options: any;
  sectionIds: any[];
  samples?: any;
};


export default class SampleComponentProcess extends React.Component<ISampleComponentPropsType, ISampleTaskComponentStateType> {

  constructor(props: ISampleComponentPropsType) {
    super(props);
    this.state = {
      options: this.props.options || [{
        id: Date.now(),
        sectionId: undefined,
        label: I18n.l("formflow.components.sampleComponent.titleSampleComponent"),
        samples: undefined
      }],
      label: undefined,
      sectionIds: [''],
    };
  }

  componentDidMount = async () => {
    await this.convertSamplesInit();
  }

  convertSamplesInit = async () => {
    const samplesValue: number[] = [];
    const newSamples: any = [];
    for (let option of this.state.options) {
      if (samplesValue.indexOf(option.samples) === -1) {
        newSamples.push({
          id: option.id,
          samples: option.samples,
          label: option.label,
          sectionId: []
        }
        )
        samplesValue.push(option.samples)
      }
    }

    for (const option of this.state.options) {
      const s = newSamples.find((e: any) => e.samples === option.samples)
      s.sectionId.push({ id: option.id, sample: option.samples, value: option.sectionId })

    }
    for (let item of newSamples) {

      if (item.sectionId[item.sectionId.length - 1].value !== undefined) {
        item.sectionId.push({ id: Date.now(), value: undefined, sample: undefined })
      }
    }
    this.setState({ samples: newSamples })
  }

  //#region HANDLERS

  handleInputLabelChange = async (evt: any) => {
    let selectGoTo: any = []
    for (const options of this.state.samples) {
      selectGoTo.push({ ...options, label: evt.target.value });
    }
    this.setState({
      samples: selectGoTo,
    });

  }

  handleInputSampleChange = (idx: any) => async (evt: any) => {
    const selectGoTo = this.state.samples.map((selectGoToItems: any, sidx: number) => {
      if (idx !== sidx) return selectGoToItems;
      return { ...selectGoToItems, samples: evt };
    });
    this.setState({ samples: selectGoTo });
    { this.onSubmitSampleComponent() }
  }

  handleInputItemChange = (idx: number, idxSection: number) => async (evt: any) => {
    const sectionId = Object.assign({}, this.state.samples);

    sectionId[idx].sectionId[idxSection].value = evt
    sectionId[idx].sectionId[idxSection].sample = sectionId[idx].samples

    this.setState({ samples: this.state.samples });
    await this.handleAddNewSection(sectionId[idx].sectionId, idxSection, idx)
    { this.onSubmitSampleComponent() }
  }


  handleAddNewSample = async () => {
    this.setState({
      samples: this.state.samples.concat([{
        id: Date.now(),
        samples: undefined,
        label: I18n.l("formflow.components.sampleComponent.titleSampleComponent"),
        sectionId: [{ id: Date.now(), value: undefined, sample: undefined }]
      }]),
    });
  }


  handleAddNewSection = async (options: any, idx: number, idxPage: number) => {
    if (options[idx].value !== undefined && options[idx + 1] === undefined) {
      const newSamples = Object.assign({}, this.state.samples);
      newSamples[idxPage].sectionId.push({ id: Date.now(), value: undefined, sample: undefined })
      this.setState({
        samples: this.state.samples,
      });
    }
  }


  handleRemoveSample = (index: number) => async () => {
    this.setState({
      samples: this.state.samples.filter((section: any, sindex: number) => index !== sindex),
    });

    if (this.state.samples.length === 0) {
      this.setState({
        samples: this.state.samples.concat([{
          id: Date.now(),
          samples: undefined,
          label: I18n.l("formflow.components.sampleComponent.titleSampleComponent"),
          sectionId: [{ id: Date.now(), value: '', sample: undefined }]
        }]),
      });
    }
    { this.onSubmitSampleComponent() }
  }

  handleRemoveSectionId = (index: number, idxSection: number) => async () => {
    const newSection = this.state.samples[index].sectionId.filter((section: any, sindex: number) => idxSection !== sindex)
    let newSample = Object.assign({}, this.state.samples);
    newSample[index].sectionId = newSection
    this.setState({
      samples: this.state.samples
    });
    { this.onSubmitSampleComponent() }
  }
  //#endregion

  onSubmitSampleComponent() {
    let newSample: ISampleOption[] = []

    for (let [idx, items] of this.state.samples.entries()) {
      for (let itemsSectionsId of items.sectionId) {
        newSample.push({
          id: itemsSectionsId.id,
          label: I18n.l("formflow.components.sampleComponent.titleSampleComponent"),
          samples: itemsSectionsId.sample,
          sectionId: itemsSectionsId.value
        })
      }
    }
    const newOptions = newSample.filter((e: any) => (e.sectionId !== undefined || e.samples !== undefined))
    this.props.onChange(newOptions)
  }



  render() {
    return (
      <React.Fragment>
        <Wrapper>
          {this.state.samples &&
            <>
              {this.state.samples.map((samplesItems: any, idx: number) => (
                <div key={idx} className={'box-sample'} style={{ width: '80%' }}>
                  {this.state.samples.length > 1 &&
                    <span onPointerDown={this.handleRemoveSample(idx)}>
                      <Icon
                        style={{ color: 'red', marginRight: '-10px', cursor: "pointer", float: 'right', marginTop: '-10px' }}
                        type="close"
                      />
                    </span>
                  }
                  <span style={{ marginRight: '10px' }}>{I18n.l("formflow.components.sampleComponent.forEach")}</span>
                  <InputNumber
                    min={0}
                    value={samplesItems.samples}
                    placeholder={'n°'}
                    onChange={this.handleInputSampleChange(idx)}
                    style={{ width: '60px' }}
                  />
                  <span style={{ marginLeft: '10px' }}>{I18n.l("formflow.components.sampleComponent.sectionIds")}</span>
                  <ProcessContext.Consumer>
                    {({ pages }) => (
                      samplesItems.sectionId.map((item: any, idxSection: number) => (
                        <>
                          <div key={idxSection}>
                            <Select
                              value={item.value}
                              onChange={this.handleInputItemChange(idx, idxSection)}
                              placeholder={I18n.l("formflow.components.goToComponent.selectGoToPlaceHolder")}
                              style={{ width: '50%', marginTop: '1rem' }}>
                              {pages.map((page: any, index: number) => (
                                <Option key={page.id} value={page.id}>
                                  {page.title}
                                </Option>
                              ))}
                            </Select>
                            {samplesItems.sectionId.length > 1 &&
                              <span onPointerDown={this.handleRemoveSectionId(idx, idxSection)}>
                                <Icon
                                  style={{ color: 'red', cursor: 'pointer' }}
                                  type="close"
                                />
                              </span>
                            }
                          </div>
                        </>
                      ))
                    )}
                  </ProcessContext.Consumer>
                </div>
              ))}
              <Row style={{ cursor: 'pointer', marginTop: '2rem' }} onPointerDown={this.handleAddNewSample}>
                <Col sm={1} md={1} xl={1} >
                  <FontAwesomeIcon color=' #1890ff' size='2x' icon={'plus-circle'} />
                </Col>
                <Col sm={4} md={4} xl={4} style={{ marginTop: '6px' }}>
                  <div style={{ color: '#354D62' }}>{I18n.l("common.addNew")}</div>
                </Col>
              </Row>
            </>
          }
        </Wrapper>
      </React.Fragment>
    );
  }
}

//#region CSS

const Wrapper = styled.div`
    .box-sample {
        background-color: #FAFAFA;
        margin-bottom: 1rem;
        border-radius: 5px;
        font-weight: bold;
        color: ${Theme.secondary.midGrey};
        padding: 1.6rem;
    }
`
//#endregion
